import React from 'react';
import Typography from '@mui/material/Typography';
import { Box, Container } from '@mui/material'; 
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';

const Offer = () => {
    return (
        // 1. div หลัก: กลับไปใช้ alignItems: 'center' เพื่อจัดกึ่งกลางเนื้อหาในแนวตั้ง
        <div 
            id='presentaion' 
            style={{ 
                width: '100%', 
                minHeight: '100vh', 
                display: 'flex', 
                alignItems: 'center', // 🔑 คืนค่าการจัดกึ่งกลางในแนวตั้ง
                justifyContent: 'center' 
            }}
        >
            <Container 
                maxWidth="lg" 
                sx={{ 
                    textAlign: 'center',
                    // 🔑 ลบ mt: { xs: '150px', sm: 0, md: 0 }, ออก (เพราะเราจะใช้ mt ที่ Box แทน)
                    // 🔑 ลบ minHeight ออก
                }}
            >
                {/* 2. Box เนื้อหาหลัก: เพิ่ม Margin Top สำหรับ Mobile เพื่อดันเนื้อหาลงมาจาก Navbar */}
                <Box
                    sx={{
                        fontFamily: 'Prompt, sans-serif', 
                        width: { xs: '90%', sm: '80%', md: '600px' }, 
                        maxWidth: '600px', 
                        mx: 'auto', 
                        p: { xs: 2, sm: 3, md: 0 }, 
                        position: 'relative', 
                        zIndex: 2,

                        // *** 🔑 การแก้ไขที่ปรับปรุง: เพิ่ม Margin Top ให้กับ Box นี้เท่านั้น ***
                        // ลองใช้ค่าที่ใหญ่กว่า 150px (เช่น 180px) เพื่อให้แน่ใจว่าพ้นพื้นที่เมนู
                        mt: { xs: '180px', sm: 0, md: 0 }, 
                    }}
                >
                    {/* --- ส่วนหัวข้อใหญ่ (THE NEW SYSTEM AI COLLETION) --- */}
                    <Typography
                        fontFamily='Prompt, sans-serif'
                        fontWeight='700' 
                        gutterBottom
                        variant='h2'
                        sx={{
                            fontSize: { xs: '2.2rem', sm: '3rem', md: '4rem', lg: '5rem' }, 
                            lineHeight: { xs: 1.1, md: 1.2 }, 
                            mb: { xs: 2, md: 3 },
                            color: 'white',
                        }}
                    >
                        <span style={{ color: 'white' }}>THE </span>
                        <span style={{ color: 'orange' }}>NEW </span>
                        <span style={{ color: 'white' }}>SYSTEM </span>
                        <span style={{ color: 'orange' }}> AI </span> <br />
                        <span style={{ color: 'white' }}>COLLELATION</span>
                    </Typography>

                    {/* --- ส่วนเนื้อหา (Paragraph) --- */}
                    <Typography
                        fontFamily='Prompt, sans-serif'
                        fontWeight='300'
                        gutterBottom
                        component='p' 
                        variant='body1' 
                        color='#fff'
                        display='block'
                        align='justify'
                        sx={{
                            fontSize: { xs: '0.85rem', sm: '0.9rem', md: '1rem' },
                            lineHeight: { xs: 1.6, md: 1.8 }, 
                            textIndent: { xs: '0em', md: '2em' },
                            mt: 0,
                            mb: '1em',
                        }}
                    >
                        บริษัท ล็อคอินส์ เมดดิคอล จำกัด ได้ดำเนินการพัฒนาระบบ
                        <span style={{ color: 'orange' }}> Correlation Lab System</span> การทำงานของระบบเป็นการวิเคราะห์ตามเงื่อนไข
                        และตัวแปรต่างๆ รวมถึงวิเคราะห์ข้อมูลจากผู้รับการตรวจแลป และแหล่งข้อมูล
                        ของโปรแกรม เพื่อหาความสอดคล้องจากข้อมูล แนะนำและให้ข้อมูลเพิ่มเติม
                        ให้สามารถหาวิธีในการตรวจเพื่อหาความแม่นยำในการวิเคราะห์ สนับสนุนข้อมูล
                        ของอุบัติโรคของผู้รับการตรวจที่ได้จากการตรวจทางแลปหรือชุดข้อมูลต่างๆ
                        ช่วยงานในห้องปฏิบัติการ ให้มีความแม่นยำและวิเคราะห์หาผลลัพธ์จาก
                        สิ่งส่งตรวจให้มีความถูกต้องมากยิ่งขึ้น โครงสร้างของตัวระบบมีการออก
                        แบบให้รองรับการทำงานร่วมกับ Machine Learning และ AI ที่เกี่ยวข้อง
                        กับระบบเอาไว้อีกด้วย เนื่องจากการใช้ AI และ Machine Learning เพื่อ
                        ตรวจจับความสัมพันธ์ เงื่อนไข ตัวแปร ที่ซับซ้อนกว่าการคำนวณแบบปกติ
                    </Typography>

                    {/* --- ส่วนปุ่ม (Stack) --- */}
                    <Stack
                        spacing={2}
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <Button
                            variant="contained"
                            size="large"
                            sx={{
                                fontFamily: 'Prompt, sans-serif',
                                backgroundColor: '#F17834',
                                color: '#fff',
                                '&:hover': {
                                    backgroundColor: 'transparent',
                                    color: '#F17834',
                                    border: '1px solid #F17834',
                                },
                            }}
                        >
                            SOON
                        </Button>
                    </Stack>
                </Box>
            </Container>
        </div>
    );
}

export default Offer;